// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__wBcmS","nav-footer":"Footer_nav-footer__jXmD1","make-by":"Footer_make-by__XeL-H"};